export class Context {
    protected constructor() {
    }
}
